import { useState } from "react";
import { CardHeader } from "@/components/ui/card";
import ChatHeaderActions from "./ChatHeaderActions";
import ChatSearchBar from "./ChatSearchBar";
import ChatPreviewList from "./ChatPreviewList";
import { ChatPreview } from "./types";
import { UserProfile } from "@/types/user";

type ChatListProps = {
  chats: ChatPreview[];
  onSelectChat: (chatId: string) => void;
  selectedChatId?: string;
  onCreateGroupChat?: (name: string, members: UserProfile[]) => void;
  onCreateNewChat?: (member: UserProfile) => void;
};

const ChatList = ({
  chats,
  onSelectChat,
  selectedChatId,
  onCreateGroupChat,
  onCreateNewChat,
}: ChatListProps) => {
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <div className="h-full flex flex-col overflow-hidden">
      <CardHeader className="flex-shrink-0 px-4 py-3 space-y-2 border-b">
        <ChatHeaderActions
          onCreateGroupChat={onCreateGroupChat}
          onCreateNewChat={onCreateNewChat}
        />
        <ChatSearchBar
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
        />
      </CardHeader>
      <div className="flex-1 min-h-0 overflow-hidden">
        <ChatPreviewList
          chats={chats}
          selectedChatId={selectedChatId}
          onSelectChat={onSelectChat}
          searchQuery={searchQuery}
        />
      </div>
    </div>
  );
};

export default ChatList;
